/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-27.
 */
import { getCurrentUser } from './index';

const ROLE_EXECUTIVE = 'ROLE_EXECUTIVE';
const ROLE_ADMIN = 'ROLE_ADMIN';
const ROLE_OPERATIVE = 'ROLE_OPERATIVE';
const ROLE_DOCUMENT_SUPPORTER = 'ROLE_DOCUMENT_SUPPORTER';
const ROLE_FINANCES = 'ROLE_FINANCES'; 

export const userHasRole = (roleToTest) => {
    try {
        const role = getCurrentUser().role;
        return role === roleToTest;
    } catch (error) {
        return false;
    }
};

export const isExecutive = () => userHasRole(ROLE_EXECUTIVE);
export const isAdmin = () => userHasRole(ROLE_ADMIN);
export const isOperative = () => userHasRole(ROLE_OPERATIVE);
export const isDocumentSupporter = () => userHasRole(ROLE_DOCUMENT_SUPPORTER);
export const isFinances = () => userHasRole(ROLE_FINANCES);

window.isExecutive = isExecutive;



// WEBPACK FOOTER //
// ./security/role.validator.js